/* Сборка контактных полей новой заявки в поддержку.
 *
 * Вынесено из компонента отдельной чистой функцией не ради красоты: именно здесь
 * решается, доедет ли телефон до сервера. Ошибка тут не видна ни в вёрстке, ни в
 * логах — заявка уходит успешно, просто БЕЗ контакта, и обнаруживается это уже
 * оператором, которому некуда звонить.
 *
 * Правила:
 * - телефон шлём и от гостя, и от авторизованного (у последнего он уедет в
 *   профиль, если тот пуст) — но только непустой: пустая строка в multipart
 *   отбрасывается клиентом, а в JSON заставила бы сервер валидировать «ничто»;
 * - имя и почта имеют смысл ТОЛЬКО у гостя: у авторизованного они уже есть в
 *   профиле, и сервер их всё равно игнорирует (services.create_ticket).
 */

/** @returns {{contact_name?:string, contact_email?:string, contact_phone?:string}} */
export function contactPayload({ guest = false, name = '', email = '', phone = '' } = {}) {
  const out = {};
  if (guest) {
    out.contact_name = (name || '').trim();
    out.contact_email = (email || '').trim();
  }
  const p = (phone || '').trim();
  if (p) out.contact_phone = p;
  return out;
}
